import script from "./SceneControls.vue?vue&type=script&setup=true&lang=js"
export * from "./SceneControls.vue?vue&type=script&setup=true&lang=js"

import "./SceneControls.vue?vue&type=style&index=0&id=0c284b3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c284b3a"]])

export default __exports__